import React from 'react';
import { Box } from '@mui/material';

/**
 * 标签页面板组件
 * 用于在标签页中显示内容
 */
function TabPanel({ children, value, index, sx }) {
  return (
    <div hidden={value !== index} style={{ height: '100%', overflow: 'hidden' }}>
      {value === index && (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', ...sx }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default TabPanel;

